import React, { memo } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import './css/Player1Tabs.css';
import { getHTMLTextFromNormalText } from '../../../../../catalog/Website';
import { isValidString } from '../../../../../catalog/Validity';
import PlaceholderComponent4 from '../../../../uiElements/placeholderComponents/placeholderComponent4/PlaceholderComponent4';

const Player1TextTab = (props) => {
    const { text } = props;

    return (
        <>
            <div className="player1-text-tab-container m-l-50px m-r-100px">
                {isValidString(text) ? (
                    <div className="player1-text-tab-container-text alegreya-font-family game-info1-text font-spacing-wider line-height-wider text-left-align m-t-0 m-b-20px font-size-l">
                        {parse(getHTMLTextFromNormalText(text))}
                    </div>
                ) : <PlaceholderComponent4 text="Unavailable" />}
            </div>
        </>
    );
};

Player1TextTab.propTypes = {
    text: PropTypes.string.isRequired,
};

export default memo(Player1TextTab);
